export abstract class EditorCursor {
}
